module.exports = __webpack_public_path__ + "static/catalog_hero_mobile-cc221f0675e8805c012e5b314c7ca101.png";